import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import Popover from '../../../base/popover/components/Popover.web';
import HangupToggleButton from './HangupToggleButton';
const MOBILE_BACKDROP_STYLE = {
    position: 'fixed',
    inset: 0,
    zIndex: 1000,
    background: 'rgba(0, 0, 0, 0.35)'
};
const MOBILE_MENU_STYLE = {
    position: 'fixed',
    right: '12px',
    bottom: 'calc(112px + env(safe-area-inset-bottom, 0px))',
    width: 'min(280px, calc(100vw - 24px))',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px',
    padding: '12px',
    borderRadius: '12px',
    background: '#242528',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.5)'
};
/**
 * A React {@code Component} for opening or closing the {@code HangupMenu}.
 *
 * @augments Component
 */
class HangupMenuButton extends Component {
    /**
     * Initializes a new {@code HangupMenuButton} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this._onCloseDialog = this._onCloseDialog.bind(this);
        this._toggleDialogVisibility
            = this._toggleDialogVisibility.bind(this);
        this._onEscClick = this._onEscClick.bind(this);
        this._onBackdropClick = this._onBackdropClick.bind(this);
    }
    /**
     * Tap outside the simple (mobile) menu closes it.
     *
     * @param {React.MouseEvent} event - The click event.
     * @returns {void}
     */
    _onBackdropClick(event) {
        event.stopPropagation();
        this._onCloseDialog();
    }
    /**
     * Keeps taps inside the simple menu from reaching the backdrop.
     *
     * @param {React.MouseEvent} event - The click event.
     * @returns {void}
     */
    _onMenuClick(event) {
        event.stopPropagation();
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onCloseDialog();
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { children, isOpen, simpleMenu, t } = this.props;
        if (simpleMenu) {
            return (React.createElement("div", { className: 'toolbox-button-wth-dialog context-menu' },
                React.createElement(HangupToggleButton, { buttonKey: 'hangup-menu', customClass: 'hangup-menu-button', handleClick: this._toggleDialogVisibility, isOpen: isOpen, notifyMode: this.props.notifyMode, onKeyDown: this._onEscClick }),
                isOpen && ReactDOM.createPortal(React.createElement("div", { onClick: this._onBackdropClick, style: MOBILE_BACKDROP_STYLE },
                    React.createElement("div", { "aria-label": t('toolbar.accessibilityLabel.hangup'), id: 'hangup-menu', onClick: this._onMenuClick, role: 'menu', style: MOBILE_MENU_STYLE }, children)), document.body)));
        }
        return (React.createElement("div", { className: 'toolbox-button-wth-dialog context-menu' },
            React.createElement(Popover, { centerDrawer: true, content: children, headingLabel: t('toolbar.accessibilityLabel.hangup'), onPopoverClose: this._onCloseDialog, position: 'top', trigger: 'click', visible: isOpen },
                React.createElement(HangupToggleButton, { buttonKey: 'hangup-menu', customClass: 'hangup-menu-button', handleClick: this._toggleDialogVisibility, isOpen: isOpen, notifyMode: this.props.notifyMode, onKeyDown: this._onEscClick }))));
    }
    /**
     * Callback invoked when {@code InlineDialog} signals that it should be
     * close.
     *
     * @private
     * @returns {void}
     */
    _onCloseDialog() {
        this.props.onVisibilityChange(false);
    }
    /**
     * Callback invoked to signal that an event has occurred that should change
     * the visibility of the {@code InlineDialog} component.
     *
     * @private
     * @returns {void}
     */
    _toggleDialogVisibility() {
        sendAnalytics(createToolbarEvent('hangup'));
        this.props.onVisibilityChange(!this.props.isOpen);
    }
}
export default translate(HangupMenuButton);
